import { render, staticRenderFns } from "./Managebanners.vue?vue&type=template&id=cd75f9c8&"
import script from "./Managebanners.vue?vue&type=script&lang=js&"
export * from "./Managebanners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports